export default "__VITE_ASSET__CKxNoaWa__"